import { Outlet } from "react-router-dom";

/**
 * Layout dédié aux routes **publiques marketing** (S7-5, GAP-3).
 *
 * À la différence de `AppLayout` :
 * - Pas de `Navbar` applicative (items inutiles pour visiteur non-engagé).
 * - **Pas de `ConsentModal`** : la landing ne touche pas aux données
 *   utilisateur, le consentement RGPD est demandé au moment de l'entrée
 *   dans l'app (`/app` et au-delà), pas à la lecture de la home.
 *
 * Décision actée S7-1 § 1.1 (option 2 — layout dédié plutôt qu'ajout de
 * `/` à `PUBLIC_PATHS`).
 */
export function LandingLayout(): JSX.Element {
  return (
    // S16-1 — `overflow-x-hidden` : même filet de sécurité que `AppLayout`
    // contre un débordement horizontal résiduel sur la landing publique.
    <div className="min-h-screen overflow-x-hidden bg-white text-slate-900">
      <Outlet />
    </div>
  );
}
